import { get, getRawValue } from '../../utils/get';
import { CONTEXT_PROPS } from '../../types/ContextProps';
import { hasMissingSchemaVariables } from '../../adapters/utils';
import { getProductFullUrl } from './calculated/get-product-full-url';
import { getImageWithThumbnailObject } from '../../adapters/get-image-with-thumbnail-object';
import { ITEM_TYPES } from '../../types/ItemTypes';
import { resolveItemTypeMultilingualUrl } from '../../utils/resolve-item-type-multilingual-url';
import { IDs } from './ids-stores-product';
import { requiredSchemaVariables } from './required-schema-variables';
export var getV1ProductData = function (item) {
    var _a;
    var mediaItems = getRawValue(item, 'product.media.items') || [];
    var imagesSD = mediaItems
        .filter(function (_a) {
        var _b = _a.thumbnail, thumbnail = _b === void 0 ? {} : _b, _c = _a.image, image = _c === void 0 ? {} : _c;
        return image.url && thumbnail.url;
    })
        .map(function (_a) {
        var _b = _a.thumbnail, thumbnail = _b === void 0 ? {} : _b, _c = _a.image, image = _c === void 0 ? {} : _c;
        return getImageWithThumbnailObject(image, thumbnail);
    });
    return _a = {},
        _a[IDs.SITE_NAME] = get(item, "context.".concat(CONTEXT_PROPS.SITE_NAME)),
        _a[IDs.BUSINESS_NAME] = get(item, "context.".concat(CONTEXT_PROPS.BUSINESS_NAME)),
        _a[IDs.INDEX_SITE] = getRawValue(item, "context.".concat(CONTEXT_PROPS.INDEX_SITE)),
        _a[IDs.INDEX_PAGE] = getRawValue(item, "context.".concat(CONTEXT_PROPS.INDEX_PAGE)),
        _a[IDs.ID] = get(item, 'product.id'),
        _a[IDs.SKU] = get(item, 'product.sku'),
        _a[IDs.TITLE] = get(item, 'product.name'),
        _a[IDs.DESCRIPTION] = get(item, 'product.description'),
        _a[IDs.BRAND] = get(item, 'product.brand'),
        _a[IDs.PRICE] = get(item, 'product.price.discountedPrice') > 0
            ? "".concat(get(item, 'product.price.discountedPrice'))
            : "".concat(get(item, 'product.price.price')),
        _a[IDs.CURRENCY] = "".concat(get(item, 'product.price.currency')),
        _a[IDs.TYPE] = get(item, 'product.productType'),
        _a[IDs.WEIGHT] = get(item, 'product.weight'),
        _a[IDs.AVAILABILITY_SCHEMA] = "".concat(get(item, 'product.stock.inStock')) === 'true'
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock',
        _a[IDs.AVAILABILITY_META_TAG] = "".concat(get(item, 'product.stock.inStock')) === 'true'
            ? 'InStock'
            : 'out of stock',
        _a[IDs.SLUG] = get(item, 'product.slug'),
        _a[IDs.MAIN_IMAGE] = get(item, 'product.media.mainMedia.image.url'),
        _a[IDs.IMAGE_WIDTH] = get(item, 'product.media.mainMedia.image.width'),
        _a[IDs.IMAGE_HEIGHT] = get(item, 'product.media.mainMedia.image.height'),
        _a[IDs.IMAGE_ALT] = get(item, 'product.media.mainMedia.image.alt'),
        _a[IDs.THUMBNAIL_URL] = get(item, 'product.media.mainMedia.thumbnail.url'),
        _a[IDs.THUMBNAIL_WIDTH] = get(item, 'product.media.mainMedia.thumbnail.width'),
        _a[IDs.THUMBNAIL_HEIGHT] = get(item, 'product.media.mainMedia.thumbnail.height'),
        _a[IDs.THUMBNAIL_ALT] = get(item, 'product.media.mainMedia.thumbnail.alt'),
        _a[IDs.SD_JSON_IMAGES] = imagesSD,
        _a[IDs.PAGE_URL] = resolveItemTypeMultilingualUrl(ITEM_TYPES.STORES_PRODUCT, item, getProductFullUrl(item)),
        _a[IDs.PRODUCT_PAGE_BASE_URL] = get(item, 'product.productPageUrl.base'),
        _a[IDs.DISABLE_SCHEMA] = hasMissingSchemaVariables(requiredSchemaVariables, item),
        _a[IDs.MEDIA_ITEMS] = mediaItems,
        _a[IDs.FULL_DESCRIPTION] = get(item, 'product.description'),
        _a;
};
